import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation updateUser($input: UserSimpleInput) {
    updateUser(input: $input) {
      user {
        id
      }
    }
  }
`;
